import React, { useContext } from 'react';
import styles from './style.css';
import { FlowContext } from '../../core/flow-engine';
import { logout } from '../../flows/shared/utils';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import trpBrandLogo from '../../assets/images/Artwork.svg';
import config from '../../config';

const FlowHeader = () => {
  const {
    debug,
    appState: {
      store: { authenticated }
    }
  } = useContext(FlowContext);

  return (
    <div data-metrics-location="HDR">
      <nav className="nav">
        <div className="navbar navbar-default">
          <div className="logo-wrapper">
            <span className="trp-trusty-img" />
            <a
              href={`${config('returnUrlPrefix')}personal-investing/home.html`}
              className="navbar-brand">
              <img src={trpBrandLogo} alt="T. Rowe Price logo" />
            </a>
          </div>

          {authenticated && (
            <div className="logout-button beacon-on-dark">
              <MFBeaconButton
                type="button"
                id="logoutBtn"
                onClick={logout}
                className="white-text"
                variant="tertiary"
                label="Log Out"
              />
            </div>
          )}
        </div>
      </nav>
      {debug}
      <style jsx>{styles}</style>
    </div>
  );
};

export default FlowHeader;
